import { createContext } from 'react';
export const ProTableSettingContext = createContext({
    tableSetting: {
        isZebra: false,
        size: 'medium',
        crossline: false,
    },
    setTableSetting: (value) => { },
    setEditType: (type) => { },
    refreshList: () => { },
    setEditRow: (row) => { },
    setRowRecord: (value) => { },
    setVisible: (visible) => { },
    setBehavior: (value) => { }
});
